import { render, staticRenderFns } from "./Setting.Detail.vue?vue&type=template&id=2930e38e&"
import script from "./Setting.Detail.vue?vue&type=script&lang=js&"
export * from "./Setting.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports